// Feature flags
export const FEATURES = {
  PHONE_OTP_ENABLED: false
};

// API configuration
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5002/api';

// Dealer Stock API — the main marketing-site backend (dealer.importjdmmagic.com).
// These endpoints are PUBLIC (no auth) and serve the same data shown on
// https://www.importjdmmagic.com/dealer-stock. This is a DIFFERENT backend/DB
// from the auction portal's own API, so dealer-stock data stays separate.
export const DEALER_STOCK_API_BASE_URL =
  process.env.REACT_APP_DEALER_API_URL || 'https://dealer.importjdmmagic.com';

// List of makers to exclude from UI display and filtering
export const EXCLUDED_MAKERS = ["BUGGY SNOWMOBILE", "CONSTRUCTION EQUIP FARMMACHINE", "FORKLIFT", "OTHER"];

// Newest model year the catalogue can hold, used only as a fallback for the year
// control when /cars/filters hasn't answered yet — the real bounds come from the
// years that endpoint returns. Most cars stop at 2002, but Ferrari and Lamborghini
// are imported up to 2005 (Backend/app/config/listingYears.js).
export const FALLBACK_YEAR_RANGE = [1990, 2005];

// GET /cars/search rejects a `search` value longer than this with a 400, so the
// search inputs and the query builder both have to respect it.
export const SEARCH_MAX_LENGTH = 64;

// User roles
export const USER_ROLES = {
  ADMIN: 'admin',
  USER: 'user',
  GUEST: 'guest'
};

// Pagination defaults
export const DEFAULT_PAGE_SIZE = 9;
export const DEFAULT_PAGE = 1;

// Local storage keys
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'auth_token',
  USER_DATA: 'user_data',
  THEME: 'theme_preference'
};

// API endpoints
export const ENDPOINTS = {
  AUTH: {
    LOGIN: '/auth/login',
    REGISTER: '/auth/register',
    FORGOT_PASSWORD: '/auth/forgot-password',
    RESET_PASSWORD: '/auth/reset-password'
  },
  CARS: {
    SEARCH: '/cars/search',
    FILTERS: '/cars/filters',
    DETAILS: '/cars/details',
    FAVORITE: '/cars/favorite'
  },
  USER: {
    PROFILE: '/user/profile',
    FAVORITES: '/user/favorites',
    SAVED_FILTERS: '/user/saved-filters'
  }
}; 